<template>
  <div class="mobile-printer">
    <p v-if="title">
      <span>{{ title }}</span>
    </p>
    <p>
      <strong>
        <a :href="realTel" >{{ printValue }}</a>
      </strong>
    </p>
  </div>
</template>
<script>
import transformDatToData from '@/mixin/transform_dat_to_data'
import { map } from 'lodash'

export default {
  mixins: [transformDatToData],
  data() {
    return {
      title: '',
      value: '',
      mask: ''
    }
  },
  computed: {
    realTel() {
      return `tel: ${this.value}`
    },
    printValue() {
      let realIdx = 0

      return map(this.mask, (val, _idx) => {
        if (!['(', ')', ' ', '-'].includes(val)) {
          val = this.value[realIdx]
          realIdx += 1
        }

        return val
      }).join('')
    }
  }
}
</script>
